import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Signup from './pages/Signup';
import OAuthCallback from './pages/OAuthCallback';
import Customers from './pages/Customers';
import Projects from './pages/Projects';
import Timesheets from './pages/Timesheets';
import Expenses from './pages/Expenses';
import Payments from './pages/Payments';
import Developers from './pages/Developers';
import DeveloperReceivables from './pages/DeveloperReceivables';
import Invoices from './pages/Invoices';

import { AuthProvider, useAuth } from './context/AuthContext';
import Settings from './pages/Settings';
import ManageUsers from './pages/ManageUsers';
import Board from './pages/Board';

const PrivateRoute = () => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return <div>Loading...</div>;
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/oauth/callback" element={<OAuthCallback />} />
          <Route element={<PrivateRoute />}>
            <Route path="/" element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="customers" element={<Customers />} />
              <Route path="projects" element={<Projects />} />
              <Route path="timesheets" element={<Timesheets />} />
              <Route path="expenses" element={<Expenses />} />
              <Route path="payments" element={<Payments />} />
              <Route path="developer-payments" element={<DeveloperReceivables />} />
              <Route path="invoices" element={<Invoices />} />
              <Route path="developers" element={<Developers />} />

              <Route path="board" element={<Board />} />
              <Route path="users" element={<ManageUsers />} />
              <Route path="settings" element={<Settings />} />

            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
